import { Button, TextField, CircularProgress } from "@material-ui/core"
import Topo from "../../../Componentes/TopCategorias"
import { useStyles } from "./style"
import { useHistory } from "react-router-dom"
import { useEffect, useState } from "react"

export function ChamadoTecnicoPage() {
    const classes = useStyles()
    const history = useHistory()

    const supportTypes = [
        {
            supportLabel: "Suporte Técnico",
            supportId: "10043"
        },
        {
            supportLabel: "Dúvidas sobre licenciamento e cobrança",
            supportId: "10044"
        },
        {
            supportLabel: "Dúvidas gerais ou sugestões",
            supportId: "10046"
        },
        {
            supportLabel: "Utilizar domínio próprio da Loja",
            supportId: "10064"
        },
        {
            supportLabel: "Trocar E-mail de cadastro",
            supportId: "10069"
        },
        {
            supportLabel: "Integração com instagram ou Facebook",
            supportId: "10070"
        },
        {
            supportLabel: "Trocar nome ou link da loja",
            supportId: "10063"
        },

    ]
    useEffect(() => {
        const email = localStorage.getItem("email");
        if (email) {
            setFormData(prev => ({
                ...prev,
                email: email
            }));
        }
    }, []);

    const [formData, setFormData] = useState({
        tipoChamado: "",
        assunto: "",
        detalhesTecnicos: ""
    })

    const [errors, setErrors] = useState({
        tipoChamado: false,
        assunto: false,
        detalhesTecnicos: false
    })

    const [loading, setLoading] = useState(false) 
    const [resposta, setResposta] = useState(null)

    const handleChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }))

        setErrors(prev => ({
            ...prev,
            [field]: false
        }))
    }

    const handleSubmit = async () => {
        const newErrors = {
            tipoChamado: formData.tipoChamado === "",
            assunto: formData.assunto.trim() === "",
            detalhesTecnicos: formData.detalhesTecnicos.trim() === ""
        };

        setErrors(newErrors);

        const hasError = Object.values(newErrors).some(error => error);

        if (!hasError) {
            setLoading(true);
            try {
                const response = await fetch('https://automatize.lionsoft.com.br/webhook/support-uppy', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                });

                const json = await response.json();
                setResposta(json);

                history.push("/suporte-tecnico/solicitacao-suporte-criada");
            } catch (error) {
                console.error('Erro ao enviar os dados:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div className="page-container">
            <div className="page-align" style={{ justifyContent: "flex-start" }}>
                <div>
                    <Topo rota={"/suporte-tecnico"} name="Abrir um chamado técnico" />
                </div>
                <div className="infinite-scroll">
                    <div className={classes.container}>
                        <div className={classes.inputContainer}>
                            <label className={classes.label}>Tipo de chamado</label>
                            <TextField
                                id="tipo-chamado"
                                select
                                fullWidth
                                variant="outlined"
                                size="medium"
                                SelectProps={{ native: true }}
                                className={classes.input}
                                value={formData.tipoChamado}
                                onChange={(e) => handleChange("tipoChamado", e.target.value)}
                                error={errors.tipoChamado}
                                helperText={errors.tipoChamado && "Campo obrigatório"}
                            >
                                <option value="">Selecione</option>
                                {supportTypes.map(({ supportLabel, supportId }) => (
                                    <option key={supportId} value={supportId}>
                                        {supportLabel}
                                    </option>
                                ))}
                            </TextField>
                        </div>
                        <div className={classes.inputContainer}>
                            <label className={classes.label}>Assunto</label>
                            <TextField
                                id="assunto"
                                placeholder="Digite o assunto do chamado"
                                variant="outlined"
                                fullWidth
                                className={classes.input}
                                value={formData.assunto}
                                onChange={(e) => handleChange("assunto", e.target.value)}
                                error={errors.assunto}
                                helperText={errors.assunto && "Campo obrigatório"}
                            />
                        </div>
                        <div className={classes.inputContainer}>
                            <label className={classes.label}>Detalhes técnicos</label>
                            <TextField
                                id="detalhes-tecnicos"
                                placeholder="Digite a descrição do chamado"
                                variant="outlined"
                                fullWidth
                                multiline
                                className={classes.input}
                                rows={20}
                                value={formData.detalhesTecnicos}
                                onChange={(e) => handleChange("detalhesTecnicos", e.target.value)}
                                error={errors.detalhesTecnicos}
                                helperText={errors.detalhesTecnicos && "Campo obrigatório"}
                                inputProps={{
                                    maxLength: 1000
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="footer-column">
                    <hr style={{ width: "100%" }} />
                    <Button
                        className={classes.buttonSave}
                        onClick={handleSubmit}
                        variant="contained"
                        disabled={loading} 
                    >
                        {loading ? (
                            <>
                                <CircularProgress size={20} color="inherit" style={{ marginRight: 8 }} />
                                Enviando...
                            </>
                        ) : (
                            "Criar solicitação"
                        )}
                    </Button>
                </div>
            </div>
        </div>
    );
}
